import { useQuery } from "react-query"
import PermintaanPerubahaDataApi from "../api/PermintaanPerubahaDataApi"

export const useDropdownModul = () => useQuery(
  ["permintaan_perubahan_data", "dropdown_modul"],
  () => PermintaanPerubahaDataApi.getHakAkses({
    tipe_hak_akses: "divisi"
  }).then((res) => res.data.data.map((item) => ({
    value: item.kode_hak_akses,
    label: item.nama_hak_akses
  }))))

export const useDropdownMenu = (params) => useQuery(
  ["permintaan_perubahan_data", "dropdown_menu", params],
  () => PermintaanPerubahaDataApi.getHakAkses({
    tipe_hak_akses: "menu",
    ...params
  }).then(res => res.data.data.map((item) => ({
    value: item.nama_hak_akses,
    label: item.nama_hak_akses
  }))),
)

export const useDropdownUrgensi = () => useQuery(
  ["permintaan_perubahan_data", "dropdown_urgensi"],
  () => PermintaanPerubahaDataApi.getDropdownUrgensi()
)

export const useGetSinglePermintaanPerubahanData = (params) => useQuery(
  ["permintaan_perubahan_data", "get_single", params],
  () => PermintaanPerubahaDataApi.getSingle(params),
)